import { gql, useQuery } from '@apollo/client';
import { ProjectStatusesEnum } from '@thinknet-gmbh/platform-common';

export const GET_PROJECTS = gql`
  query getProjects($payload: GetProjectsInput!) {
    getProjects(payload: $payload) {
      collection {
        _id
        name
        deputyMemberId
      }
      totalCount
    }
  }
`;

export const useGetProjectsByProjectOwner = (
  projectOwnerId: string,
  projectStatuses?: ProjectStatusesEnum[]
) => {
  const { data, loading } = useQuery(GET_PROJECTS, {
    variables: {
      payload: {
        projectOwnerId,
        projectStatuses,
      },
    },
    skip: !projectOwnerId,
    fetchPolicy: 'no-cache',
  });

  const projects = data?.getProjects?.collection || [];
  const totalCount = data?.getProjects?.totalCount || 0;

  return { projects, totalCount, loading };
};
